export default "__VITE_ASSET__QR5Pyqr4__"